import React from 'react';
import {useStudioMode} from '../../StudioMode/StudioModeProvider';
import {useSelector} from 'react-redux';
import {RootState} from '../../../store';
import {useIntl} from 'react-intl';

export const MaxSecondsMessage = () => {
  const intl = useIntl();
  const studioMode = useStudioMode();
  const serverConfig = useSelector((state: RootState) => state.config);

  if (studioMode.mode === 'LITE' && serverConfig.maxJobRuntimeSeconds) {
    return (
      <p>
        {intl.formatMessage(
          {
            id:
              studioMode.name === 'core'
                ? 'studioCore.inference.duration.warning'
                : 'studioLite.inference.duration.warning',
          },
          {seconds: serverConfig.maxJobRuntimeSeconds}
        )}
      </p>
    );
  }

  return <></>;
};
